import {FC, ReactElement} from 'react';
import {observer} from 'mobx-react-lite';
import {Box, Center} from '@chakra-ui/react';
import {ProjectOut} from 'api';
import {Header} from 'ui-kit/headers';
import {TDeveloperModeModel, TUserModel} from 'core/models';
import {ECalculationStatus} from 'core/enums';

import {
  PlayIconButton,
  SaveIconButton,
  UserIconButton,
  StatusIconButton,
  PlaySelectedIconButton,
  InspectorIconButton
} from './components';

interface IProps {
  projectInfo: ProjectOut;
  currentUser: TUserModel;
  developerMode: TDeveloperModeModel;
  runStatus: ECalculationStatus | null;
  isRunning: boolean;
  isRunDisabled?: boolean;
  isPartRunAvailable?: boolean;
  lastSaveDate: Date | null;
  additionalActions?: ReactElement;
  onToggleJournal: () => void;
  onRunCalculation: () => void;
  onRename: (newName: string) => Promise<void>;
  onExport: () => Promise<void>;
  onRestore: () => Promise<void>;
  onDelete: () => Promise<void>;
  onSignOut: () => void;
  onSave: () => void;
}

const ProjectMainBarFC: FC<IProps> = ({
  projectInfo,
  currentUser,
  developerMode,
  runStatus,
  isRunning,
  isRunDisabled,
  isPartRunAvailable,
  lastSaveDate,
  additionalActions,
  onRunCalculation,
  onToggleJournal,
  onExport,
  onRename,
  onDelete,
  onRestore,
  onSignOut,
  onSave
}) => {
  return (
    <Header
      project={projectInfo}
      isDeveloperMode={developerMode.isActive}
      onToggleDeveloperMode={developerMode.toggleActive}
      onRename={onRename}
      onExport={onExport}
      onRestore={onRestore}
      onDelete={onDelete}
    >
      <Center gap="8px">
        {!!additionalActions && (
          <>
            {additionalActions}
            <Box w="1px" bg="border" h="32px" />
          </>
        )}
        <PlayIconButton isDisabled={isRunning || isRunDisabled} onRun={onRunCalculation} />
        {isPartRunAvailable && <PlaySelectedIconButton isDisabled={isRunning || isRunDisabled} />}
        <StatusIconButton runStatus={runStatus} isDisabled={isRunning} onClick={onToggleJournal} />

        <Box w="1px" bg="border" h="32px" />
        <SaveIconButton isDisabled={isRunning} lastSaveDate={lastSaveDate} onSave={onSave} />
        <UserIconButton currentUser={currentUser} onSignOut={onSignOut} />

        {developerMode.isActive && (
          <>
            <Box w="1px" bg="border" h="32px" />
            <InspectorIconButton
              isActive={developerMode.isInspector}
              onToggle={developerMode.toggleFieldInspector}
            />
          </>
        )}
      </Center>
    </Header>
  );
};

export const ProjectMainBar = observer(ProjectMainBarFC);
